import { render, staticRenderFns } from "./kr.vue?vue&type=template&id=40265df7&scoped=true"
import script from "./kr.vue?vue&type=script&lang=js"
export * from "./kr.vue?vue&type=script&lang=js"
import style0 from "./kr.vue?vue&type=style&index=0&id=40265df7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40265df7",
  null
  
)

export default component.exports